// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1Vfrn","column":"style_column__3JEcq","row":"style_row__ZSJk7"};